import React from "react";

function AnnouncmentCenter() {
    return (
        <>
            <p className="rounded-md border border-green-400 bg-green-200 p-4">
                WisNu sedang membuka pendaftaran untuk Mitra atau penyelenggara
                destinasi wisata, silahkan untuk melakukan pendaftaran untuk
                proses registrasi yang cepat.
            </p>
        </>
    );
}

export default AnnouncmentCenter;
